module.exports = __webpack_public_path__ + "img/hr-car-4.8a3ba885.png";